import { render } from "./SalaryCalculator.vue?vue&type=template&id=b41ddce8&scoped=true&ts=true"
import script from "./SalaryCalculator.vue?vue&type=script&lang=ts"
export * from "./SalaryCalculator.vue?vue&type=script&lang=ts"

import "./SalaryCalculator.vue?vue&type=style&index=0&id=b41ddce8&lang=scss&scoped=true"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b41ddce8"]])

export default __exports__